import * as types from '../../constants/ActionTypes';


export const getMessages = id => ({
    type: types.GET_MESSAGES,
    id,
});

export const getMessagesSuccess = response => ({
    type: types.GET_MESSAGES_SUCCESS,
    response,
});

export const conversationError = response => ({
    type: types.CONVERSATION_ERROR,
    response,
});

// The same as replyToConversation. However, in the saga we do not chain a call to fetch all messages.
export const limitedLoginSendMessage = request => ({
    type: types.LIMITED_LOGIN_SEND_MESSAGE_REQUEST,
    formData: request,
});

export const limitedLoginSendMessageSuccess = response => ({
    type: types.LIMITED_LOGIN_SEND_MESSAGE_SUCCESS,
    response,
});

export const limitedLoginSendMessageError = response => ({
    type: types.LIMITED_LOGIN_SEND_MESSAGE_ERROR,
    response,
});

export const replyError = response => ({
    type: types.REPLY_ERROR,
    response,
});

export const replyToConversation = request => ({
    type: types.REPLY_TO_CONVERSATION,
    formData: request,
});